import { createFileRoute } from '@tanstack/react-router';
import { MinePage } from '@/features/work/ui/MinePage';

export const Route = createFileRoute('/_authenticated/work/')({ component: () => <MinePage /> });
